import { abbreviateName, formatCurrency } from '../../utils/format';
import styles from './Podium.module.css';

const MEDALS = ['🥇', '🥈', '🥉'];

/** "Sean O'C." -> "SO" */
function initials(name) {
  return name
    .split(/\s+/)
    .map((part) => part.replace(/[^A-Za-z]/g, '').charAt(0))
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase();
}

/** Top three, ordered 2nd - 1st - 3rd so the winner sits in the middle. */
function Podium({ traders }) {
  const [first, second, third] = traders;
  const places = [
    { trader: second, place: 2 },
    { trader: first, place: 1 },
    { trader: third, place: 3 },
  ].filter((entry) => entry.trader);

  return (
    <ol className={`${styles.podium} d-flex align-items-center justify-content-center gap-2 mb-4`}>
      {places.map(({ trader, place }) => (
        <li key={trader.userId} className={`${styles.place} d-flex flex-column align-items-center`}>
          <div className={styles.avatarWrap}>
            <span
              className={`${styles.avatar} ${place === 1 ? styles.avatarWinner : ''} d-flex align-items-center justify-content-center`}
            >
              {initials(trader.name)}
            </span>
            <span className={`${styles.medal} d-flex align-items-center justify-content-center`}>
              <span aria-hidden="true">{MEDALS[place - 1]}</span>
              <span className="visually-hidden">{`Rank ${place}`}</span>
            </span>
          </div>
          <span className={`${styles.name} mt-2`}>{abbreviateName(trader.name)}</span>
          <span className={styles.amount}>{formatCurrency(trader.netWithdrawals)}</span>
        </li>
      ))}
    </ol>
  );
}

export default Podium;
